import React from 'react';

import BottomSlider from '../BottomSlider/BottomSlider';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const ModuleBannerCarousel = ({
  isMobile,
  slides,
  primaryColor,
  uiVariantBannerCarousel,
}) => {
  const renderModuleBannerCarouselDesktop = () => {
    return (
      <div className="hidden-mobile container">
        <BottomSlider
          slides={slides}
          primaryColor={primaryColor}
          uiVariantBannerCarousel={uiVariantBannerCarousel}
        />
      </div>
    );
  };

  const renderModuleBannerCarouselMobile = () => {
    return (
      <div className="hidden-desktop mobile-module-banner-carousel">
        {slides.map((slide, i) => {
          return (
            <div key={slide.id} className="banner">
              <a href={slide.link} aria-label={`Guarda l'offerta`}>
                <ImageDispatcher
                  src={slide.imgUrl}
                  alt={slide.seoName}
                  className={`img-fluid ${i > 0 ? 'lazyload' : ''}`}
                  style={{
                    borderRadius: uiVariantBannerCarousel === '1' ? '12px' : 0,
                  }}
                />
              </a>
            </div>
          );
        })}
      </div>
    );
  };

  const renderModuleBannerCarousel = () =>
    isMobile
      ? renderModuleBannerCarouselMobile()
      : renderModuleBannerCarouselDesktop();

  return <>{renderModuleBannerCarousel()}</>;
};

export default ModuleBannerCarousel;
